module.exports = __webpack_public_path__ + "img/926-007259.png";